import { minimize_str } from "@core/helpers/string";

// a form builder form with its current version, by id or by key (web-server getFormDefinition; never carries the
// form's sms setup or its creator)
export const GET_FORM_DEFINITION = minimize_str(`
  query ($id: ID, $key: String) {
   result: getFormDefinition(id: $id, key: $key) {
    id
    title
    description
    lang
    key
    requires_login
    captcha_enabled
    auto_save
    current_version
    version {
     id
     version
     groups
    }
   }
  }
`);
